import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import {
  HeartGreyIcon,
  AngryFaceGreyIcon,
  DislikeGreyIcon,
} from 'Stories/Icon/Icon.stories'
import { thankValue, offensiveValue, poorValue } from 'Constants/constants'
import { SelectResponseRatingProps } from './props'
import {
  Select,
  SelectOption,
  SelectOptionIcon,
  SelectOptionText,
} from './styles'

const SelectResponseRatingComponent: FunctionComponent<SelectResponseRatingProps> = ({
  ref,
  onChange,
  value,
}) => {
  const { t } = useTranslation()
  const reviewResponseTextOptions = [
    {
      value: thankValue,
      label: (
        <SelectOption>
          <SelectOptionIcon>
            <HeartGreyIcon />
          </SelectOptionIcon>
          <SelectOptionText>
            {t('campaignResultsPage.thankYou')}
          </SelectOptionText>
        </SelectOption>
      ),
    },
    {
      value: offensiveValue,
      label: (
        <SelectOption>
          <SelectOptionIcon>
            <AngryFaceGreyIcon />
          </SelectOptionIcon>
          <SelectOptionText>
            {t('campaignResultsPage.soundsOffensive')}
          </SelectOptionText>
        </SelectOption>
      ),
    },
    {
      value: poorValue,
      label: (
        <SelectOption>
          <SelectOptionIcon>
            <DislikeGreyIcon />
          </SelectOptionIcon>
          <SelectOptionText>
            {t('campaignResultsPage.notUsefullFeedback')}
          </SelectOptionText>
        </SelectOption>
      ),
    },
  ]

  return (
    <Select
      ref={ref}
      fill
      isSearchable={false}
      options={reviewResponseTextOptions}
      placeholder={t('campaignResultsPage.chooseResponse')}
      classNamePrefix="review-response"
      value={reviewResponseTextOptions.find(c => c.value === value)}
      onChange={(val: { value: { value: number } }) => onChange(val.value)}
    />
  )
}

export default SelectResponseRatingComponent
